import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'games',
      'jobs',
      'teams',
      'domains',
      'members',
    ]),
  },
  methods: {
    getName(key, row) {
      const name = [];
      const value = row[key];
      let returnValue;

      switch (key) {
        case 'name':
          returnValue = `${value} ( ${row.email.split('@')[0]} )`;
          break;
        case 'job':
          value.forEach((job) => {
            name.push(this.jobs[job].name);
          });
          returnValue = name.join(',');
          break;
        case 'team':
          returnValue = this.teams[value].name;
          break;
        case 'division':
          value.forEach((division) => {
            if (division === 'all') {
              name.push('팀의 모든 게임');
            } else {
              name.push(this.games[division].full_name);
            }
          });
          returnValue = name.join();
          break;
        case 'exception': {
          value.forEach((exception) => {
            name.push(exception);
          });
          returnValue = name.join('<br>');
          break;
        }
        default:
          returnValue = value;
          break;
      }
      return returnValue;
    },
  },
};




// WEBPACK FOOTER //
// ./src/mixins/getName.js